import { render, staticRenderFns } from "./event-settings.vue?vue&type=template&id=721dc08c"
import script from "./event-settings.vue?vue&type=script&lang=js"
export * from "./event-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports